import throttle from 'lodash.throttle';

export default class MatchHeight {
  constructor(elems, options) {
    this.DOMElements = elems;
    this.options = {
      variableName: '--matched-height',
      max: 0,
      ...options,
    };

    this.heights = {
    };

    this.init();
  }

  init() {
    if (!this.DOMElements.length) {
      throw new Error('MatchHeight cannot be initialised, no augmentable elements found');
    }

    this.createGroups();
    this.throttledEqualise = throttle(this.equalise, 16);
    window.setTimeout(this.equalise.bind(this), 0);
    window.addEventListener('resize', this.throttledEqualise.bind(this), false);
  }

  createGroups() {
    this.DOMElementGroups = [];

    [...this.DOMElements].forEach((el) => {
      const identifer = el.dataset?.match;
      if (identifer !== undefined) {
        if (
          this.DOMElementGroups[identifer] === undefined
          || this.DOMElementGroups[identifer].length === 0
        ) {
          this.DOMElementGroups[identifer] = [];
        }
        this.DOMElementGroups[identifer].push(el);
      }
    });
  }

  equalise() {
    this.DOMElements.forEach((el) => {
      const identifer = el.dataset?.match;
      el.style.setProperty(this.options.variableName, 'auto');

      if (this.heights[identifer]) {
        if (el.offsetHeight > this.heights[identifer]) {
          this.heights[identifer] = el.offsetHeight;
        }
      } else {
        this.heights[identifer] = el.offsetHeight;
      }
    });

    if (this.DOMElementGroups.length > 0) {
      this.handleGroup();
    } else {
      this.matchHeight(this.DOMElements);
    }
  }

  handleGroup() {
    this.DOMElementGroups.forEach((group) => {
      this.matchHeight(group);
    });
  }

  matchHeight(elements) {
    elements.forEach((el) => {
      const identifer = el.dataset?.match;
      el.style.setProperty(this.options.variableName, `${this.heights[identifer]}px`);
    });
  }
}
